define(["./userPreferencesModule"], function (userPreferencesModule) {
    "use strict";

    return userPreferencesModule.service("monitoringUserPreferencesService", ["$localStorage", "monitoringUserPreferencesProperties",
        function ($localStorage, monitoringUserPreferencesProperties) {
            var MONITORABLE_VIEW_TYPE_STORAGE_KEY = "monitorableCurrentViewType";

            return {
                savePreferences: savePreferences,
                getPreferencesOrDefault: getPreferencesOrDefault
            };

            function savePreferences(preferences) {
                if (monitoringUserPreferencesProperties.isStorePreferencesActive()) {
                    $localStorage[MONITORABLE_VIEW_TYPE_STORAGE_KEY] = preferences;
                }
            }

            function getPreferencesOrDefault(defaultPreferences) {
                if (monitoringUserPreferencesProperties.isStorePreferencesActive()) {
                    return $localStorage[MONITORABLE_VIEW_TYPE_STORAGE_KEY] || defaultPreferences;
                }
                return defaultPreferences;
            }
        }]);
});